import createCsEnRenderer from "./createCsEnRenderer";

export { default as Aktivni } from "./Aktivni";
export { default as AnoNe } from "./AnoNe";
export { default as Date } from "./Date";
export { default as DateTime } from "./DateTime";
export { default as DayOfWeek } from "./DayOfWeek";
export { default as DateAktivita } from "./DateAktivita";
export { default as DoplnkoveSluzby } from "./DoplnkoveSluzby";
export { default as DoplnkoveSluzbyNazev } from "./DoplnkoveSluzbyNazev";
export { default as Kolize } from "./Kolize";
export { default as RendererHodinaInterval } from "./RendererHodinaInterval";
export { default as Termin } from "./Termin";
export { default as UzivatelInfo } from "./UzivatelInfo";
export { default as Zadavatel } from "./Zadavatel";
export { default as ZadostHistorie } from "./ZadostHistorie";
export { default as ZadostHistorieItem } from "./ZadostHistorieItem";
export { default as ZadostHistorieItemPoznamka } from "./ZadostHistorieItemPoznamka";
export { default as ZadostPoznamky } from "./ZadostPoznamky";
export { default as ZadostPoznamkyItem } from "./ZadostPoznamkyItem";
export { default as ZadostStavLabel } from "./ZadostStavLabel";

export const CsEnNazev = createCsEnRenderer("nazev");
export const CsEnPopis = createCsEnRenderer("popis");
export const CsEnVyznam = createCsEnRenderer("vyznam");
